function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211.99,
    height: 158.45,
    fill: "none",
    viewBox: "0 0 211.99 158.45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    stroke: "#dfdfdf",
    strokeLinejoin: "round",
    strokeWidth: 1.8784
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.93922,
    y: 0.93922,
    width: 210.11,
    height: 156.57,
    rx: 17.857,
    ry: 17.857,
    fill: "#f7f7f7",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.127,
    cy: 42.231,
    r: 17.005,
    fill: "#f2f2f2",
    stopColor: "#000000",
    strokeLinecap: "round",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.487 134.63 49.728-49.729 18.412 18.412 42.501-42.501 18.24 18.239 15.314-15.314 40.821 70.893z",
    fill: "#f2f2f2",
    stopColor: "#000000",
    strokeLinecap: "round",
    style: {
      fontVariationSettings: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewPlaceholder);
export default __webpack_public_path__ + "static/media/preview-placeholder.8a712f348c672e336fd318babd153d55.svg";
export { ForwardRef as ReactComponent };